import { GridLegacy, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React from "react";
import { ImgURL } from "../../../Url";
import { getIcons } from "../../Tools/Tools";

export default function StatusButtonCardMode({ icon, handleStatuses, changeStatus }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [statuses, setStatuses] = React.useState([]);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = (json) => {
    return json.map((item, index) => {
      const { Disabled: disabled, Caption: text, Image: img, Status: status, Current: current } = item,
        selected = current === "1";
      return (
        <MenuItem
          onClick={() => {
            handleClose();
            changeStatus(status);
          }}
          disabled={disabled}
          selected={selected}
          style={{ height: "25px" }}
          key={"ButtonsMenuStatus" + index}
        >
          <ListItemIcon>{ImgURL(img)}</ListItemIcon>
          <ListItemText>{text}</ListItemText>
        </MenuItem>
      );
    });
  };

  return (
    <div style={{ display: "grid", justifyContent: "center" }}>
      <IconButton
        sx={{ width: "42px" }}
        onClick={(e) => {
          handleStatuses().then((res) => {
            setStatuses(res);
            setAnchorEl(e.target);
          });
        }}
      >
        {ImgURL(getIcons(icon), { width: "24px" })}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <GridLegacy container direction="row" justifyContent="flex-start" alignItems="center">
          <GridLegacy
            item
            style={{
              backgroundColor: "#e6e6e6",
              position: "absolute",
              height: "100%",
              width: "46px",
            }}
          />
          <GridLegacy item>{menuItems(statuses)}</GridLegacy>
        </GridLegacy>
      </Menu>
    </div>
  );
}
